import React from "react";

const TableHeader = ({ isAdmin }) => (
  <thead>
    <tr>
      <th scope="col" className="border-0">
        #
      </th>
      <th scope="col" className="border-0">
        Title
      </th>
      <th scope="col" className="border-0">
        Slug
      </th>
      <th scope="col" className="border-0">
        View Count
      </th>
      <th scope="col" className="border-0">
        Status
      </th>
      {isAdmin ? (
        <th scope="col" className="border-0">
          Publisher
        </th>
      ) : null}
      <th scope="col" className="border-0">
        Published Date
      </th>
      <th scope="col" className="border-0">
        Action
      </th>
    </tr>
  </thead>
);

export default TableHeader;
